import { useEffect, useState } from "react";
import axios from "axios";

const API = "https://figazuresql.swancreate.com/api/crm";

let _cache = null;
let _promise = null;
function fetchContent() {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = axios
      .get(`${API}/sk12_sitecontent`)
      .then((r) => {
        _cache = {};
        (r.data || []).forEach((row) => { _cache[row.ContentKey] = row.ContentValue; });
        return _cache;
      })
      .catch(() => { _cache = {}; return _cache; });
  }
  return _promise;
}

// Returns a content(key, fallback) function. Until loaded (or if missing/empty), fallback is used.
export function useSiteContent() {
  const [map, setMap] = useState(_cache || {});
  useEffect(() => {
    let on = true;
    fetchContent().then((m) => { if (on) setMap({ ...m }); });
    return () => { on = false; };
  }, []);
  return (key, fallback) =>
    map[key] !== undefined && map[key] !== null && map[key] !== "" ? map[key] : fallback;
}
